import { MatrixClient } from 'matrix-js-sdk/src/matrix';

import { isMatrixIdFormat } from 'modules/CreateWorkspaceModal/WorkspaceInviteStep/WorkspaceInviteForm/utils';

import { isMatrixUserNotFoundError } from './isMatrixUserNotFoundError';
import { validateMatrixUserExists } from './validateMatrixUserExists';

export type MatrixInviteePartition = {
  validInvitees: string[];
  invalidMatrixIds: string[];
};

export async function partitionInviteesByMatrixUserExistence(
  matrixClient: MatrixClient,
  invitees: string[]
): Promise<MatrixInviteePartition> {
  const validInvitees: string[] = [];
  const invalidMatrixIds: string[] = [];

  for (const invitee of invitees) {
    if (!isMatrixIdFormat(invitee)) {
      validInvitees.push(invitee);
      continue;
    }

    try {
      const exists = await validateMatrixUserExists(matrixClient, invitee);
      if (exists) {
        validInvitees.push(invitee);
      } else {
        invalidMatrixIds.push(invitee);
      }
    } catch (error) {
      if (isMatrixUserNotFoundError(error)) {
        invalidMatrixIds.push(invitee);
        continue;
      }

      throw error;
    }
  }

  return { validInvitees, invalidMatrixIds };
}
